import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class LocationSelectorService {

    resetLocation$ = new Subject<void>();

    resetLocation() {
        this.resetLocation$.next();
    }
}